import(/* webpackMode: "eager" */ "/codebuild/output/src1766684577/src/frontend-v2/app/global-error.tsx");
